import { useState } from "react";
import { Phone, CalendarClock } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import CallbackDialog from "@/components/forms/CallbackDialog";

export default function FloatingCTA() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        data-testid="floating-cta-cluster"
        className="fixed z-40 right-4 sm:right-6 bottom-4 sm:bottom-6 flex flex-col sm:flex-row gap-3 items-end"
      >
        <button
          data-testid="floating-schedule-btn"
          onClick={() => setOpen(true)}
          className="group inline-flex items-center gap-2 bg-white border border-brand-line text-brand-ink rounded-full px-5 py-3.5 font-semibold text-sm shadow-[0_12px_40px_rgba(0,0,0,0.12)] hover:bg-brand-limestone transition-all hover:-translate-y-0.5"
        >
          <CalendarClock className="w-4 h-4" strokeWidth={2} />
          <span className="hidden sm:inline">Schedule Callback</span>
          <span className="sm:hidden">Schedule</span>
        </button>
        <a
          data-testid="floating-call-btn"
          href={BUSINESS.phoneHref}
          className="inline-flex items-center gap-2 bg-brand-obsidian text-white rounded-full px-5 py-3.5 font-semibold text-sm shadow-[0_12px_40px_rgba(0,0,0,0.18)] hover:bg-brand-obsidian-hover transition-all hover:-translate-y-0.5"
        >
          <Phone className="w-4 h-4" strokeWidth={2} />
          <span className="hidden sm:inline">Free Consultation · {BUSINESS.phone}</span>
          <span className="sm:hidden">Call Now</span>
        </a>
      </div>

      <CallbackDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
